export default "/assets/wh-close-mobile.png";